import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table} from 'semantic-ui-react';
import {enterKeyCode, tabKeyCode} from '../../../../../common/constants/keyCodes';
import {getTotalColumn, getTotalColumnPart, falsePrincipalPart, validateUnique} from '../../../../utils';
import {Actions} from '../../../../../common/actions';
import Loader from '../../../../../common/components/loader';
import FormParts from './form';
import DisplayData from './data';

const initialState = {
  'id': '',
  'principalPart': false,
  'fr': '',
  'quantity': 0.0,
  'price': 0.0,
  'description': '',
  'company': '',
  'priceTde': 0.0,
  'priceClaimProvider': 0.0,
  'part': '',
  'frTde': '',
  'fob': 0.0,
  'cost': 0.0,
  'searchPart': false,
};

class Parts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
  }

  componentDidUpdate() {
    const {part} = this.props;
    if (this.state.id === part.code && this.state.searchPart) {
      this.setState({
        'description': part.name,
        'fr': part.franchise,
        'price': part.pvpToyotaEcuador,
        'cost': part.cost,
        'fob': part.fob,
        'priceClaimProvider': part.fob * 1.3,
        'priceTde': part.pvpToyotaEcuador,
        'searchPart': false,
      });
    }
  }

  handleUpdateAmount = (field, value, selectItem) => {
    const {parts, handleChangeForm} = this.props;
    const newParts = parts.map((item) => {
      if (item.id === selectItem.id) {
        return {
          ...selectItem,
          [field]: +value,
        };
      }
      return item;
    });
    handleChangeForm('parts', newParts);
  }
  
  handleUpdatePrincipalPart = (data, selectItem) => {
    const {parts, handleChangeForm} = this.props;
    const updatePrincipalPart = parts.map((item) => {
      if (item.id === selectItem.id) {
        return {
          ...selectItem,
          'principalPart': data.checked ? 'S' : 'N',
        };
      }
      return {
        ...item,
        'principalPart': 'N',
      };
    });
    handleChangeForm('parts', updatePrincipalPart);
    handleChangeForm('principalPart', selectItem.id);
    handleChangeForm('principalPartDescription', selectItem.description);
  }

  handleAddItem = () => {
    const {handleChangeForm} = this.props;
    const {principalPart, id, fr, quantity, price, cost, fob,
      description, priceTde, priceClaimProvider} = this.state;
    const newParts = [...this.props.parts];
    const item = {
      id,
      fr,
      cost,
      fob,
      'priceTde': +priceTde,
      'quantity': +quantity,
      'price': +price,
      'priceClaimProvider': +priceClaimProvider,
      'total': +price * +quantity,
      'principalPart': principalPart ? 'S' : 'N',
      description,
    };

    if (validateUnique(newParts, 'id', id)) {
      const parts = principalPart ? falsePrincipalPart(newParts, 'principalPart') : newParts;
      parts.push(item);
      this.setState({
        ...initialState,
      }, () => {
        handleChangeForm('parts', parts);

        if (principalPart) {
          handleChangeForm('principalPart', id);
          handleChangeForm('principalPartDescription', description);
        }
      });
    } else {
      this.props.addMessageBoxError(`El item ${id} ya se encuentra en la lista`);
    }
  }

  handleKeyDown = (e) => {
    const {id} = this.state;
    if (e.keyCode === enterKeyCode || e.keyCode === tabKeyCode) {
      if (id.length > 1) {
        this.props.getWarrantyAdminPart(id);
        this.setState({
          'searchPart': true,
        });
      }
      e.preventDefault();
    }
  }

  handleRemoveItem = (id) => {
    const {handleChangeForm} = this.props;
    const parts = [...this.props.parts].filter((item, idx) => idx !== id);
    handleChangeForm('parts', parts);
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
      'description': field === 'id' ? '' : this.state.description,
    });
  }

  render() {
    const {loading, parts, disabledBtns} = this.props;
    if (loading) {
      return <div className='twc-loader-subcontracts' >
        <Loader/>
      </div>;
    }

    return (
      <div>
        <div className='warranty-container-table'>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Repuesto Principal</Table.HeaderCell>
                <Table.HeaderCell>No. de parte</Table.HeaderCell>
                <Table.HeaderCell>Fr TDE</Table.HeaderCell>
                <Table.HeaderCell>Descripción Repuesto TDE</Table.HeaderCell>
                <Table.HeaderCell>Cantidad</Table.HeaderCell>
                <Table.HeaderCell>Precio Reclama Dealer</Table.HeaderCell>
                <Table.HeaderCell>Precio Venta a Dealer</Table.HeaderCell>
                <Table.HeaderCell>Precio Paga TDE</Table.HeaderCell>
                <Table.HeaderCell>Costo de TDE</Table.HeaderCell>
                <Table.HeaderCell>Fob Parte TDE</Table.HeaderCell>
                <Table.HeaderCell>Precio Reclama a fábrica</Table.HeaderCell>
                <Table.HeaderCell>Precio Total Dealer</Table.HeaderCell>
                <Table.HeaderCell>Precio Total TDE</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!disabledBtns && (
                <FormParts
                  handleChange={this.handleChange}
                  {...this.state}
                  handleAddItem={this.handleAddItem}
                  handleCheckBox={this.handleCheckBox}
                  handleKeyDown={this.handleKeyDown}
                  loading={loading}
                />
              )}
              {parts.map((part, idx) => (
                <DisplayData
                  disabledBtns={disabledBtns}
                  handleUpdatePrincipalPart={this.handleUpdatePrincipalPart}
                  handleUpdateAmount={this.handleUpdateAmount}
                  key={idx}
                  item={part}
                  idx={idx}
                  handleRemoveItem={this.handleRemoveItem}
                />
              ))}
              <Table.Row className='warranty-table-footer'>
                <Table.Cell />
                <Table.Cell />
                <Table.Cell />
                <Table.Cell>SUBTOTAL</Table.Cell>
                <Table.Cell>
                  {getTotalColumn(parts, 'quantity')}{' '}
                </Table.Cell>
                <Table.Cell />
                <Table.Cell />
                <Table.Cell />
                <Table.Cell>
                  {'$'}{getTotalColumn(parts, 'cost')}{' '}
                </Table.Cell>
                <Table.Cell>
                  {'$'}{getTotalColumn(parts, 'fob')}{' '}
                </Table.Cell>
                <Table.Cell>
                  {'$'}{getTotalColumn(parts, 'priceClaimProvider')}{' '}
                </Table.Cell>
                <Table.Cell>
                  {'$'}{getTotalColumnPart(parts, 'price', 'quantity').toFixed(2)}
                </Table.Cell>
                <Table.Cell>
                  {'$'}
                  {getTotalColumnPart(parts, 'priceTde', 'quantity').toFixed(2)}
                </Table.Cell>
                <Table.Cell />
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loading': state.warrantiesAdminCategories.loading,
    'part': state.warrantiesAdminCategories.part,
  };
};

const {getWarrantyAdminPart, addMessageBoxError} = Actions;

export default connect(mapStateToProps, {
  getWarrantyAdminPart,
  addMessageBoxError,
})(Parts);
